import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { logout } from '../store/slices/authSlice';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

const PrivateRoute = ({ children }) => {
  const { token } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  useEffect(() => {
    // Check if token is expired
    const tokenExpiration = localStorage.getItem('tokenExpiration');
    if (tokenExpiration) {
      const expirationTime = parseInt(tokenExpiration);
      const currentTime = new Date().getTime();
      
      if (currentTime >= expirationTime) {
        // Token expired
        dispatch(logout());
        toast.error('Your session has expired. Please login again.');
      }
    }
  }, [dispatch]);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;

